<template>
  <div>


      <b-row>
        <b-col md="10">
          <h4 class="font-weight-bold ml-1">Lusetelling</h4>
        </b-col>

        <!-- <b-col md="1">
          <div class="float-right">
            <label class="nav-item navbar-text navbar-search-box p-0 active">
              <i class="ion ion-ios-search navbar-icon align-middle"></i>
              <span class="navbar-search-input pl-2">
                <b-form-input
                  class="ml-2"
                  v-model="filter"
                  placeholder="Search"
                ></b-form-input>
              </span>
            </label>
          </div>
        </b-col> -->

        <b-col md="2">
          <b-button class="float-right" variant="primary" @click="newLicecount()">Opprett lusetelling</b-button>
      </b-col>

      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        caption-top
        stacked="sm"
        :items="licecount"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :tbody-tr-class="rowCompleted"
        empty-text="There are no Licecount logs to show"
      >
        <template v-slot:table-caption>Antall tellinger: {{ licecount.length | numeralFormat }}
        </template>

        <template v-slot:cell(week)="data">
          <b-link class="link strong" :href="'#/customer/licecount-customer-edit/' + data.item.id">
            <span v-if="data.item.week != null">{{ data.item.week}} - {{ data.item.year}} </span> 
          </b-link>
           
        </template>

          <template v-slot:cell(title)="data">
          <b-link class="link strong" :href="'#/customer/licecount-customer-edit/' + data.item.id">
            <span v-if="data.item.site != null"> {{ data.item.site.number }} - {{ data.item.site.name }}</span>
          </b-link>
        </template>  
     
        <template v-slot:cell(fishcount)="data">
          <span v-if="data.item.details.fish != null">{{ data.item.details.fish.length }} </span>  
        </template>

        <template v-slot:cell(lice_female)="data">
          <span v-if="data.item.details.lice_female != null">{{ data.item.details.lice_female | numeralFormat("0,0[.]00") }} </span>  
        </template>

        <template v-slot:cell(lice_moving)="data">
          <span v-if="data.item.details.lice_moving != null">{{ data.item.details.lice_moving | numeralFormat("0,0[.]00") }} </span>  
        </template>

        <template v-slot:cell(lice_persist)="data">
          <span v-if="data.item.details.lice_persist != null">{{ data.item.details.lice_persist | numeralFormat("0,0[.]00") }} </span>  
        </template>

        <template v-slot:cell(wellfare)="data">
          <span v-if="data.item.details.wellfare != null">{{ data.item.details.wellfare | numeralFormat("0,0[.]00") }} </span>  
        </template>

        <template v-slot:cell(temperature)="data">
          <span v-if="data.item.details.temperature_sea != null">{{ data.item.temperature_sea | numeralFormat("0,0[.]00") }} </span>  
        </template>

        <template v-slot:cell(createdAt)="data">
          {{ $date(data.value).format("DD.MM.YYYY HH:mm") }}
        </template> 

        <template v-slot:cell(user)="data">
           <span v-if="data.item.user_username != null"> {{ data.item.user_username }}</span>
        </template> 

        <template #cell(actions)="row">
          <b-button variant="primary" class="mr-1 float-center" size="sm" @click="editLicecount(row.item.id)">
            Rediger</b-button>
        </template>

  
      </b-table>

      <b-row>
        <b-col
          md="1"
          class="my-1"
        >
          <b-form-group class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col
          md="2"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <br />


    <!-- New Licecount modal -->

      <b-modal
        id="newLicecount"
        title="Ny lusetelling"
      >

      <b-row>
        <b-col>

          <label>Uke</label>
          <b-form-input class="mb-3" v-model="newlicecount.week" placeholder="Ukenummer" type="number"></b-form-input>

        </b-col>

        <b-col>

          <label>År</label>
          <b-form-input class="mb-3" v-model="newlicecount.year" placeholder="År" type="number"></b-form-input>

        </b-col>

      </b-row>
     
          <label>Lokasjon</label>
          <vue-typeahead-bootstrap class="mb-3" v-model="querySites" :ieCloseFix="false" :data="sites"
                  :serializer="(item) => item.number + ' - ' + item.name" @hit="site = $event"
                  placeholder="Søk lokaliteter" @input="lookupSites" />

          <label>Merd</label>
          <b-form-input class="mb-3" v-model.number="newlicecount.cage" placeholder="Merd"></b-form-input>

          <label>Temperatur sjø</label>
          <b-form-input class="mb-3" max="30" step="0.1" v-model.number="newlicecount.temperature_sea" type="number" placeholder="Temperatur sjø"></b-form-input>

        <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="primary"
              class="float-right"
              @click="saveLicecount()"
            >
              Opprett
            </b-button>

            <b-button
              variant="default"
              class="float-right mr-2"
              @click="closeLicecount()"
            >
              Avbryt
            </b-button>
          </div>
        </template>
      </b-modal>

  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";
import {debounce } from "lodash";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

var dayjs = require('dayjs')
var weekOfYear = require('dayjs/plugin/weekOfYear')
dayjs.extend(weekOfYear)



export default {
  components: {
    
    Datepicker,
    VueMoment,
    moment,
    VueTypeaheadBootstrap
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      user: {},
      licecount: [],
      newlicecount: {
        year: dayjs().year(),
        week: dayjs().week(),
        cage: "",
        temperature_sea: 0
      },
      order: {},
      orders: [],
      customer_company: {},
      supplier_company: {},
      companies: [],
      site: {},
      sites: [],
      queryOrder: "",
      queryCompany: "",
      querySites: "",
      lastUpdate: {},
      fromDate: {},
      toDate: {},
      disabledDates: {},
      fields: [
        { key: "week", label: "Uke", sortable: true },
        { key: "title", label: "Lokasjon", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "cage", label: "Merd", sortable: true },   
        { key: "fishcount", label: "Antall fisk", sortable: true },
        { key: "lice_female", label: "Hunnlus", sortable: true },
        { key: "lice_moving", label: "Bevegelige", sortable: true },
        { key: "lice_persist", label: "Fastsittende", sortable: true },
        { key: "createdAt", label: "Opprettet", sortable: true },
        { key: "user", label: "Opprettet av", sortable: true },
        { key: "actions", label: "", sortable: true },
        
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [25, 50, 100, 250, 500, 1000],
      sortBy: "week",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      limit: 1000,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumLicecountTotal() {
      return this.licecount.length;
    },
  },
  methods: {
    getUser() {
        axios.get("https://api.eines-as.no/users/me").then((res) => {
          this.user = res.data;
          this.customer_company = res.data.company;
        });
    },
    getLicecount() {
      this.isLoading = true;
      var company = localStorage.getItem("company");

      axios
        .get("https://api.eines-as.no/licecounts?_sort=createdAt:DESC&_where[customer_company]=" + company)
        .then((res) => {
          this.licecount = res.data;
          this.isLoading = false;
        });
    },
    saveLicecount() {

      this.isLoading = true;

        // Create object and save licecount
        
        var liceData = {
          week: this.newlicecount.week,
          year: this.newlicecount.year,
          customer_company: this.customer_company.id,
          site: this.site.id,
          site_number: this.site.number,
          site_name: this.site.name,
          cage: this.newlicecount.cage.toString(),
          temperature_sea: this.newlicecount.temperature_sea,
          user_username: this.user.username,
          user_company: this.customer_company.name,
          details: {
              fish: []
          },
        }

        axios.post("https://api.eines-as.no/licecounts", liceData)
          .then((response) => {
            console.log(response.data)
            this.$router.push("/customer/licecount-edit/" + response.data.id);
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
        
    },
    editLicecount(licecountId) {
        this.$router.push("/customer/licecount-customer-edit/" + licecountId);
      },
    newLicecount() {
      this.$bvModal.show("newLicecount");
    },
    closeLicecount() {
      this.$bvModal.hide("newLicecount");
    },
    rowCompleted(item, type) {
      if (!item || type !== "row") return;
      if (item.type == "Ut telling") return "table-success";
    },
    lookupOrders: debounce(function () {
        // Search and lookup companies from API

        var company = localStorage.getItem("company");

        axios
          .get(`https://api.eines-as.no/orders?_where[supplier_company]=` + company `&_q=${this.queryOrder}`)
          .then((response) => {
            this.orders = response.data;
          });
      }, 250),
      lookupCompanies: debounce(function () {
        // Search and lookup companies from API
        axios
          .get(`https://api.eines-as.no/companies?_q=${this.queryCompany}`)
          .then((response) => {
            this.companies = response.data;
          });
      }, 250),
      lookupSites: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(`https://api.eines-as.no/sites?_q=${this.querySites}`)
          .then((response) => {
            this.sites = response.data;
          });
      }, 250),
  },
  created: function () {
    this.getUser()
    this.getLicecount();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.flscellmaxwidth {
  max-width: 300px;
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}

.table .table-success,
.table .table-success > th,
.table .table-success > td {
  background-color: #e4fae9;
}
</style>